import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSecurity = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0.966797C8.9412 0.966797 9.84423 1.34035 10.5098 2.00586C11.1753 2.67138 11.5488 3.57445 11.5488 4.51562V6.19336H12.791C13.0671 6.19343 13.291 6.41726 13.291 6.69336V14.5332C13.291 14.8093 13.0671 15.0331 12.791 15.0332H3.20898C2.93285 15.0332 2.709 14.8093 2.70898 14.5332V6.69336C2.70898 6.41722 2.93284 6.19336 3.20898 6.19336H4.45117V4.51562C4.45119 3.57445 4.82474 2.67138 5.49023 2.00586C6.15577 1.34033 7.0588 0.966813 8 0.966797ZM3.70898 14.0332H12.291V7.19336H3.70898V14.0332ZM7.99902 9.24219C8.27515 9.24219 8.49899 9.46607 8.49902 9.74219V11.4844C8.49902 11.7605 8.27517 11.9844 7.99902 11.9844C7.72288 11.9844 7.49902 11.7605 7.49902 11.4844V9.74219C7.49906 9.46607 7.7229 9.24219 7.99902 9.24219ZM8 1.9668C7.32401 1.96681 6.67526 2.2349 6.19727 2.71289C5.71931 3.19088 5.45119 3.83967 5.45117 4.51562V6.19336H10.5488V4.51562C10.5488 3.83967 10.2807 3.19088 9.80273 2.71289C9.32473 2.23492 8.67598 1.9668 8 1.9668Z",
		fill: "currentColor"
	})
});
export default SvgSecurity;
